<template>
  <b-container class="h-100">
    <div v-if="error" key="error" class="p-5">
      <BError>{{ error }}</BError>
    </div>

    <div v-else key="loading" class="bc-spinner" />
  </b-container>
</template>

<script>
import BError from '@/components/ui/BError'
export default {
  name: 'ImplicitCallback',
  components: {BError},
  data() {
    return {
      error: null
    }
  },
  async beforeMount() {
    this.error = this.$route.query.error_description || null
    if (this.$route.query.code && this.$route.query.code.length > 0) { //got code from okta
      try {
        await this.$auth.handleLoginRedirect()
        this.$emit('authenticated') //trigger App to get user
      } catch (e) {
        this.error = e.message
      }
    } else {
      if(!this.error) {
        this.$router.push('/') //something went wrong, probably user entered url manually, redirect to root
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  padding-top: 4rem;
}
</style>
